import _ from 'underscore';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    render: function() {
        var custom_data = this.model.get('custom_data');

        var custom_data_items = '';

        _.each(custom_data, function(data, label) {
            custom_data_items +=
            '<div>' +
                '<div class="title" title="' + Util.htmlEntities(label) + '">' + Util.htmlEntitiesWithA(label) + ':</div>' +
                '<div class="value">' + (Util.htmlEntitiesWithA(data, true) || '-') + '</div>' +
            '</div>';
        });

        var content =
        '<div class="item-header item-header-collapsible">' +
            '<span>Custom Data</span>' +
            (_.size(custom_data) ?
            '<span class="item-count badge-secondary-invert badge-round badge-fluid">' + _.size(custom_data) + '</span>' : '') +
        '</div>' +

        '<div class="item-content box-neutral-light">' +
            (custom_data_items || 'No custom data captured. <a target="help" rel="noopener" href="https://support.userback.io/en/articles/5209197-add-a-custom-field-to-your-widget">Find out more</a>.') +
        '</div>';

        this.$el.html(content);

        this.$el.find('.item-content').toggleClass('empty', custom_data_items ? false : true);

        return this;
    }
});